import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/Elements/Button';
import { Modal } from 'react-responsive-modal';
import { Form, InputField, SelectField } from '@/components/Form';
import { TextAreaField } from '@/components/Form/TextareaField';
import { z } from 'zod';
import { AddForm } from '@/api/SendMessage/add';
import { useNotificationStore } from '@/stores/notifications';
import { InputPhone } from '@/components/Form/InputPhone';
import { isValidMobile, isValidMobileMsg } from '@/utils/validation';
import { useAuth } from '@/lib/auth';
import { createChat } from '@/api/Chat/createChat';
const schema = z.object({
  name: z.string().min(1, 'Please enter your full name').max(30, 'Can`t exceed 30 characters'),
  investment_amount: z.string().optional(),
  company_name: z
    .string()
    .min(1, 'Please enter company name')
    .max(30, 'Can`t exceed 30 characters'),
  // last_name: z.string().min(1, 'Please enter the last name').max(30, 'Can`t exceed 30 characters'),
  // gender: z.string().min(1, 'Please select the gender'),
  // dob: z.string().refine(
  //   (dateString) => {
  //     const date = new Date(dateString);
  //     const age = new Date().getFullYear() - date.getFullYear();
  //     return age >= 18;
  //   },
  //   {
  //     message: 'You must be at least 18 years old.',
  //   }
  // ),
  email: z.string().min(1, 'Please enter email address').email('Please enter valid email address!'),
  message: z.string().min(1, 'Please enter the message'),
  telephone: z.custom(isValidMobile, isValidMobileMsg),
});
type FormData = z.infer<typeof schema>;

export type ConfirmationDialogProps = {
  propType: string;
  propId: string;
  userId: string;
  show: boolean;
  invest?: boolean;
  isBusiness?: boolean;
  fullData?: any;
  setShow: (i: boolean) => void;
  refetch: () => void;
};

export const SendMessage = ({
  propType,
  propId,
  userId,
  fullData,
  show,
  isBusiness = false,
  invest,
  setShow,
  refetch,
}: ConfirmationDialogProps) => {
  const { user } = useAuth();
  const { addNotification } = useNotificationStore();

  const navigate = useNavigate();
  let canInvestAmount;
  if (isBusiness) {
    canInvestAmount = fullData?.cost - fullData?.total_investment;
  } else {
    canInvestAmount = fullData?.maximum_drawing - fullData?.total_investment;
    // console.log('canInvestAmount', canInvestAmount);
  }
  const canInvest = (investMentAmount: any) => {
    if (investMentAmount > canInvestAmount) {
      return false;
    } else {
      return true;
    }
  };

  const onHideModal = () => {
    setShow(false);
  };

  const handdleSubmit = async (value: any) => {
    if (value?.investment_amount) {
      if (!canInvest(value?.investment_amount)) {
        addNotification({
          type: 'error',
          title: 'Error',
          message: `You can invest maximum $${canInvestAmount}`,
        });
        return;
      }
    }
    const payload = { ...value, project_id: propId, property_type: propType, customer_id: userId };
    console.log('payload', payload);
    try {
      const res: { message: string } = await AddForm(payload);
      console.log(res);
      addNotification({
        type: 'success',
        title: 'Succes',
        message: res?.message ?? `Created succesfully`,
      });
      setShow(false);
      refetch();

      console.log('dchj', user);
      const ress: any = await createChat(payload.customer_id);
      console.log('ress', ress);
      navigate(`/user/chat?id=${payload.customer_id}&sid=${ress?.twilio_channel_sid}`);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <Modal open={show} onClose={onHideModal} center>
        <section className="model-datas feature-modal ">
          <div className="property-info-form">
            <Form<FormData, typeof schema>
              onSubmit={handdleSubmit}
              id="my-form"
              schema={schema}
              options={{
                defaultValues: {
                  name: user?.first_name + ' ' + user?.last_name,
                  email: user?.email,
                  telephone: user?.phone_number,
                },
              }}
            >
              {({ register, formState, getValues, control }) => (
                <>
                  {console.log(formState.errors)}
                  <div className="row form-block">
                    <div className="col-12 col-md-12 mb-2">
                      <InputField
                        label="Full Name"
                        placeholder="Write a text here.."
                        error={formState.errors['name']}
                        registration={register('name')}
                        disabled
                      />
                    </div>
                    <div className="col-12 col-md-12 mb-2">
                      <InputField
                        label="Company Name"
                        placeholder="Write a text here.."
                        error={formState.errors['company_name']}
                        registration={register('company_name')}
                      />
                    </div>
                    <div className="col-12 col-md-12 mb-2">
                      <InputField
                        type="text"
                        label="Email"
                        error={formState.errors['email']}
                        registration={register('email')}
                        placeholder="Enter email"
                        disabled
                      />
                    </div>
                    <div className="col-12 col-md-12 mb-2">
                      <InputPhone
                        label="Mobile Number"
                        floating
                        error={formState.errors['telephone']}
                        registration={register('telephone')}
                        value={user?.phone_number}
                      />
                    </div>
                    {invest && (
                      <div className="col-12 col-md-12 mb-2">
                        <InputField
                          label="Investment Amount"
                          type="number"
                          error={formState.errors['investment_amount']}
                          registration={register('investment_amount')}
                          value={user?.investment_amount}
                          placeholder="How much you want to invest?"
                        />
                      </div>
                    )}

                    {/* <div className="col-12 col-md-6 mb-4">
                      <InputField
                        label="Last Name"
                        placeholder="Write a text here.."
                        error={formState.errors['last_name']}
                        registration={register('last_name')}
                      />
                    </div> */}
                    {/* <div className="sb-category ">
                      <label>Gender</label>
                      <SelectField
                        options={[
                          { label: 'Male', value: 'male' },
                          { label: 'Female', value: 'female' },
                          { label: 'Other', value: 'other' },
                        ]}
                        label=""
                        placeholder="Select Gender"
                        error={formState.errors['gender']}
                        registration={register('gender')}
                        {...control}
                      />
                    </div> */}

                    {/* <InputField
                      type="date"
                      label="DOB"
                      error={formState.errors['dob']}
                      registration={register('dob')}
                      placeholder="Select D.O.B"
                    /> */}

                    <div className="col-12 col-md-12 mb-2">
                      <TextAreaField
                        rows={4}
                        error={formState.errors['message']}
                        registration={register('message')}
                        label="Message"
                        placeholder="Write here"
                      />
                    </div>
                  </div>

                  <p className="btn-lines gap-3 d-flex ">
                    <Button className="pink-btn" size="sm" type="submit">
                      Send Message
                    </Button>

                    <Button variant="outline" className="" onClick={onHideModal}>
                      Cancel
                    </Button>
                  </p>
                </>
              )}
            </Form>
          </div>
        </section>
      </Modal>
    </>
  );
};
